G.Reasons = function Reasons(optChangeListener, optChangeListenerContext) {
  var hasAnyChangedSignal = new Phaser.Signal();
  var reasons = new Map();

  optChangeListener && hasAnyChangedSignal.add(optChangeListener, optChangeListenerContext);

  return {
    add: add,
    remove: remove,
    setPresence: setPresence,
    hasAnyChangedSignal: hasAnyChangedSignal,
    has: has,
    hasAny: hasAny,
    hasNone: hasNone,
  };

  function setPresence(reason, present) {
    if (present) { 
      add(reason);
    } else {
      remove(reason);
    }
  };

  function add(reason, optIncrement) {
    var hadAny = hasAny();
    reasons.set(
      reason,
      optIncrement ? (reasons.get(reason) || 0) + 1 : (reasons.get(reason) || 1)
    );
    if (!hadAny && hasAny()) {
      hasAnyChangedSignal.dispatch(true);
    }
  };

  function remove(reason, optDecrement) {
    var hadAny = hasAny();
    if (optDecrement) {
      var newCount = (reasons.get(reason) || 0) - 1;
      if (newCount < 0) {

      }
      reasons.set(reason, newCount);
    } else {
      reasons.delete(reason);
    }
    if (hadAny && !hasAny()) {
      hasAnyChangedSignal.dispatch(false);
    }
    return !has(reason);
  };

  function has(reason) {
    return reasons.has(reason) && reasons.get(reason) > 0;
  };

  function hasAny() {
    return !hasNone();
  };

  function hasNone() {
    return getActiveReasonsCount() === 0;
  };

  function toString() {
    return (
      Array.from(reasons.keys())
    ).map(function(reason) {
      return reason.toString();
    }).join(", ");
  };

  function getActiveReasonsCount() {
    var count = 0;
    reasons.forEach(function(value) {
      if (value > 0) {
        ++count;
      }
    });
    return count;
  };

};